/*
  Drive Live — « Voir plus de produits » (snippets/dl-load-more.liquid)
  Récupère la page suivante de la grille via la Section Rendering API et ajoute
  ses produits à la suite. Délégué sur document : la grille peut être remplacée
  (filtres Dawn, puces dl-collection-chips.js) sans perdre le comportement.
*/
(() => {
  if (window.dlLoadMoreReady) return;
  window.dlLoadMoreReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-dl-more-button]');
    if (!button || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const grid = document.getElementById('product-grid');
    const more = button.closest('[data-dl-more]');
    if (!grid || !grid.dataset.id || !more) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    const url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', grid.dataset.id);

    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Chargement…';
    grid.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = Array.from(doc.querySelectorAll('#product-grid > li'));
      const nextMore = doc.querySelector('[data-dl-more]');
      if (!items.length) throw new Error('empty');

      items.forEach((item) => grid.appendChild(document.adoptNode(item)));
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();

      if (nextMore) {
        const back = nextMore.querySelector('.dl-more__back');
        if (back) back.remove();
        more.replaceWith(document.adoptNode(nextMore));
      } else {
        more.remove();
      }

      const status = document.querySelector('[data-dl-more-status]');
      if (status) status.textContent = `${items.length} produit${items.length > 1 ? 's' : ''} ajouté${items.length > 1 ? 's' : ''}`;

      // Le clavier reprend là où les nouveaux produits commencent.
      const firstLink = Array.from(items[0].querySelectorAll('a[href]')).find(
        (link) => link.tabIndex !== -1 && link.getClientRects().length > 0
      );
      if (firstLink) firstLink.focus({ preventScroll: true });
    } catch (error) {
      window.location.assign(button.href);
    } finally {
      grid.setAttribute('aria-busy', 'false');
    }
  });
})();
